// extracted by mini-css-extract-plugin
export default {"inputs":"ReservesDetails_inputs__wFs6+","section":"ReservesDetails_section__wFiAc","section__fields":"ReservesDetails_section__fields__TcePe"};